import React, {Component} from "react";
import './Skills.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDesktop } from '@fortawesome/free-solid-svg-icons'
import { faDatabase } from '@fortawesome/free-solid-svg-icons'
class Skills extends Component {

    render() {
        return(
            <section className={"Skills"} id={"section3"}>
                <h2 style={{color: "#857a7a"}}>Skills</h2>
                <div className="hr"/>
                <div className="skillsDiv">
                    <div className="skillType">
                                      <div className="skillTitle">Familiar with</div>
                        <div className="skillImage"> <FontAwesomeIcon icon={faDesktop}/></div>
                        <div className="skill">kotlin</div>
                        <div className="skill">Java</div>
                        <div className="skill">MVVM architecture</div>
                        <div className="skill">Jetpack compose</div>
                        <div className="skill">RESTful APIs - Retrofit</div>
                        <div className="skill">Kotlin Coroutines</div>
                        <div className="skill">Kotlin flows</div>
                    </div>
                </div>
            </section>
        )
    }

}

export default Skills
